import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { sessionRSVPAllowed } from "@utilscommon";
import SessionAssign from "./session-assign";

const AssignRSVPSessions = (props) => {
  const {
    // Parent
    source,

    // Own
    eventData,
    manageTicketsCount,
    assignedAttendeeTickets,
  } = props;
  // console.log("manageTicketsCount :- ", manageTicketsCount);

  const renderAssign = () => {
    let returnHtml = [];

    for (const [key, item] of Object.entries(assignedAttendeeTickets)) {
      let tid = key;

      let ticketCheck = _.filter(
        manageTicketsCount,
        (obj) => parseInt(obj?.ticketid) === parseInt(tid)
      );
      // console.log("ticketCheck :- ", ticketCheck);

      if (ticketCheck?.[0]?.rsvpsessions?.length > 0) {
        let ticket = ticketCheck[0];
        // Check for ticket session rsvp related setting
        let ticketSessionSettings = sessionRSVPAllowed(
          ticket,
          eventData?.eventtimezone
        );
        // console.log({ ticketSessionSettings });

        for (let i = 0; i < item?.length; i++) {
          let finalitem = item?.[i];
          finalitem.index = i;
          finalitem.position = 1 + i;

          returnHtml.push(
            <SessionAssign
              key={`tickets_key_${tid}_${i}`}
              form={`SessionAssignForm_${tid}_${i}`}
              ticketinfo={ticket}
              assign={finalitem}
              source={source}
              ticketSessionSettings={ticketSessionSettings}
            />
          );
        }
      }
    }

    return returnHtml;
  };

  return (
    <>
      {!_.isEmpty(assignedAttendeeTickets) ? (
        <ul className="space-y-3">{renderAssign()}</ul>
      ) : (
        ""
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    eventData: state.eventData,
    manageTicketsCount: state.manageTicketsCount,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignRSVPSessions);
